import { useMemo } from 'react';
import { FiltererOptions, SorterOptions } from '../constants';
import getStatusUpdate from '../utils/getStatusUpdate';
import getVersionDetails from '../utils/getVersionDetails';
import { isSelfDescribingEvent } from '../utils/versionEventLabels';
import useActivitiesQueries from './useActivitiesQueries';
import useFilters from './useFilters';
function getActivityDate(activity) {
    if ('datetime' in activity && activity.datetime) {
        return new Date(activity.datetime).getTime();
    }
    if ('createdAt' in activity && activity.createdAt) {
        return new Date(activity.createdAt).getTime();
    }
    // Use current date as fallback to avoid grouping issues
    console.warn('Activity missing datetime and createdAt fields:', activity);
    return new Date().getTime();
}
function isNoteActivity(activity) {
    return 'notes' in activity;
}
function validToShowActivity(activity) {
    return (isNoteActivity(activity) ||
        getVersionDetails(activity).length > 0 ||
        !!getStatusUpdate(activity) ||
        isSelfDescribingEvent(activity));
}
export default function useActivities({ buildingId, inspectionId, invoiceId, workOrderId, deficiencyId, proposalId }) {
    const { data: filtersData } = useFilters();
    const { activities, isLoading, hasMore, fetchMore } = useActivitiesQueries({
        buildingId,
        inspectionId,
        invoiceId,
        workOrderId,
        deficiencyId,
        proposalId,
        params: {
            type: (filtersData === null || filtersData === void 0 ? void 0 : filtersData.filters) && (filtersData === null || filtersData === void 0 ? void 0 : filtersData.filters.length) > 0 ? filtersData.filters : Object.values(FiltererOptions)
        }
    });
    const groupedActivities = useMemo(() => {
        const activitiesSorted = (filtersData === null || filtersData === void 0 ? void 0 : filtersData.sort) === SorterOptions.OldestToNewest ? activities : [...activities].reverse();
        return activitiesSorted.filter(validToShowActivity).reduce((acc, activity) => {
            const activityDate = new Date(getActivityDate(activity));
            const date = activityDate.toLocaleString('default', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            const existingDate = acc.find((item) => item.date === date);
            if (!existingDate) {
                acc.push({ date, activities: [activity] });
            }
            else {
                existingDate.activities.push(activity);
            }
            return acc;
        }, []);
    }, [activities, filtersData === null || filtersData === void 0 ? void 0 : filtersData.sort]);
    return {
        groupedActivities,
        isLoading,
        hasMore,
        fetchMore
    };
}
